export const DEFAULT_SPEED = 20;
export const DEFAULT_SCROLL_SHIFT = 200;
